import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MainLayoutComponent } from './main-layout.component';
import { MenuComponent } from '../../menu/menu.component'
import { LoaderComponent } from 'src/app/core/loader/loader.component';
import { LoaderService } from 'src/app/core/loader/loader.service';
import { AppMaterialModule } from '../../app-material/app-material.module';
import { HeaderService } from 'src/app/header/shared/header.service';

@NgModule({
  declarations: [
    LoaderComponent,
    MenuComponent,
    MainLayoutComponent,
        
  ],
  imports: [
    CommonModule,
    RouterModule,
    AppMaterialModule
  ],
  exports: [
    MainLayoutComponent,
  ],
  providers:[
    LoaderService,
    HeaderService,],
    
      schemas: [NO_ERRORS_SCHEMA]
})
export class MainLayoutModule { }

